const LOCAL_STORAGE_KEYS = {
  smsTimer: 'smsTimer',
  iroShareEmailsList: 'iroShareEmailsList',
} as const;

export default LOCAL_STORAGE_KEYS;
